import { List, ListItem, ListProps } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IPasswordStrengthCheckerProps {
  passwordValue: string;
  listProps?: ListProps;
}

const PasswordStrengthChecker: React.FC<IPasswordStrengthCheckerProps> = ({ passwordValue, listProps }) => {
  const { t } = useTranslation(['components']);
  return (
    <List
      position="absolute"
      top="75px"
      left="0"
      bg="primary.900"
      color="white"
      p="3"
      fontSize="13px"
      borderRadius="10px"
      zIndex="100"
      opacity={0}
      visibility="hidden"
      data-testid="password-strength-checker"
      {...listProps}
    >
      <ListItem color={passwordValue.length > 7 ? 'success.500' : 'secondary.500'}>
        {passwordValue.length > 7 ? <>&#x2713;</> : <>&#x21;</>} {t('components:passwordMustContainAtLeast8Characters')}
      </ListItem>
      <ListItem color={passwordValue.match(/[0-9]/) ? 'success.500' : 'secondary.500'}>
        {passwordValue.match(/[0-9]/) ? <>&#x2713;</> : <>&#x21;</>} {t('components:passwordMustContainAtLeast1number')}
      </ListItem>
      <ListItem color={passwordValue.match(/[a-z]/) ? 'success.500' : 'secondary.500'}>
        {passwordValue.match(/[a-z]/) ? <>&#x2713;</> : <>&#x21;</>}{' '}
        {t('components:passwordMustContainAtLeast1LowercaseCharacter')}
      </ListItem>
      <ListItem color={passwordValue.match(/[A-Z]/) ? 'success.500' : 'secondary.500'}>
        {passwordValue.match(/[A-Z]/) ? <>&#x2713;</> : <>&#x21;</>}{' '}
        {t('components:passwordMustContainAtLeast1UppercaseCharacter')}
      </ListItem>
      <ListItem
        color={passwordValue.match(/[!"#$%&\'()*+,\-\.\/:;<=>?@\[\\\]^_`{|}~]/) ? 'success.500' : 'secondary.500'}
      >
        {passwordValue.match(/[!"#$%&\'()*+,\-\.\/:;<=>?@\[\\\]^_`{|}~]/) ? <>&#x2713;</> : <>&#x21;</>}{' '}
        {t('components:passwordMustContainAtLeast1SpecialCharacterOf.@$!%*#&^')}
      </ListItem>
    </List>
  );
};

export default PasswordStrengthChecker;
